import React from 'react'
import merge from 'lodash/merge'
import { ContainerProps } from './Container.types'

const Container: React.FC<ContainerProps> = ({ style, className = '', children, spacing = 8 }) => {
    const mappedChildren = React.Children.map(children, (child) => {
        // if (React.isValidElement(child)) {
        //   return React.cloneElement(child, { spacing })
        // }
        return child
    })

    const _style = merge(style, {
        padding: `${spacing}px`,
    })

    return (
        <div style={_style} data-testid='Container' className={`r-container ${className}`}>
            {mappedChildren}
        </div>
    )
}

export default Container
